import { Course } from '../../../db/courses/types';
import { CourseRole } from '../../../db/shared/types';
import i18n, { i18nNS } from '../../../i18n';
import { format } from '../../../utils/datetime';
import {
  getCanSeeActivities,
  getCanSeeComments,
  getCanSeeQueries,
  getNumUnseenActivities,
  getNumUnseenComments,
  getQueriesCount,
} from '../../CourseWidget/helpers';

function getAriaDuration(course: Course) {
  if (!course.status.isLive) return i18n.t('unpublished_course', { ns: i18nNS.COURSES });
  const startDate = format(course.schedule.startDate, 'MMM dd, yyyy');
  const endDate = format(course.schedule.endDate, 'MMM dd, yyyy');
  return i18n.t('course_duration_colon_startdate_enddate', { ns: i18nNS.COURSES, startDate, endDate });
}

function getAriaRole(course: Course) {
  const translatedRole = i18n.t(course.myRole, { ns: i18nNS.GLOSSARY });
  if (course.myRole === CourseRole.ADMIN || course.myRole === CourseRole.INSTRUCTOR) {
    return i18n.t('an_role', { ns: i18nNS.GLOSSARY, role: translatedRole });
  }

  return i18n.t('a_role', { ns: i18nNS.GLOSSARY, role: translatedRole });
}

function getAriaRoleStatement(course: Course) {
  const ariaRole = getAriaRole(course);
  return i18n.t('you_are_role', { ns: i18nNS.COURSES, role: ariaRole });
}

function getAriaActivityStatement(course: Course) {
  const canSeeQueries = getCanSeeQueries(course);
  const queriesCount = getQueriesCount(course);

  const canSeeActivities = getCanSeeActivities(course);
  const numUnseenActivities = getNumUnseenActivities(course);

  const canSeeComments = getCanSeeComments(course);
  const numUnseenComments = getNumUnseenComments(course);

  const messages = [];

  if (canSeeQueries) {
    messages.push(i18n.t('N_queries', { ns: i18nNS.COURSES, count: queriesCount }));
  }

  if (canSeeActivities) {
    messages.push(i18n.t('N_activities', { ns: i18nNS.COMMON, count: numUnseenActivities }));
  }

  if (canSeeComments) {
    messages.push(i18n.t('N_comments', { ns: i18nNS.COMMON, count: numUnseenComments }));
  }

  if (messages.length === 0) return '';

  return i18n.t('messages_needs_your_attention', { ns: i18nNS.COURSES, messages });
}

export function getCourseDescription(course: Course) {
  return [getAriaDuration(course), getAriaRoleStatement(course), getAriaActivityStatement(course)]
    .filter((item) => item)
    .join(', ');
}
